<template>
  <div class="animated fadeIn">
    <b-form @submit="addOrUpdatePersonRecord">
      <b-row>
        <b-col md="9" sm="12" class="mb-4">
          <h3 v-if="this.person.id" class="card-title mb-0">{{ this.person.id }}</h3>
          <h3 v-if="!this.person.id" class="card-title mb-0">Create New Person</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <!-- Person Form -->
          <PersonForm
            v-bind:person="person"
            :chooseOrganization="true"
            @updateVictimInfo="updateVictimInfo"
          ></PersonForm>

          <b-row align-h="end">
            <b-col cols="auto" class="p-3">
              <b-button variant="link" href="#/dashboard">Cancel</b-button>
              <b-button variant="primary" @click="addOrUpdatePersonRecord">Submit</b-button>
              <b-button v-if="isAllowedToSharePerson" variant="success" @click="addOrUpdatePersonRecordAndShare">Submit and Share</b-button>
            </b-col>
          </b-row>
          <b-modal v-if="createdPerson.id && !shareAddon" title='Success' :visible=showCreatedModal @ok="handleOk" header-bg-variant="success" header-text-variant="light" size="sm" centered id="modal1" ok-only>
            <h4>Person Record Created Successfully</h4>
            <p>{{ createdPerson.id }}</p>
          </b-modal>
          <b-modal v-if="createdPerson.id && shareAddon" title='Success' :visible=showCreatedModal @ok="handleShare" header-bg-variant="success" header-text-variant="light" size="sm" centered id="modal1" ok-only>
            <h4>Person Record Created Successfully!</h4>
            <p>{{ createdPerson.id }}</p>
            <p>Click OK to set the Sharing Settings.</p>
          </b-modal>
        </b-col>
      </b-row>
    </b-form>
    <!-- Share New -->
    <CreateSharePersonModal
      :person="person"
      :personId="personId"
      :personFid="personFid"
      :personOrganizationOwner="personOrganizationOwner"
      :selectedGroup="selectedGroup"
      v-on:createAndSharePerson="reroutePerson($event)"
    ></CreateSharePersonModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PersonForm from '@/views/t1/PersonForm'
import CreateSharePersonModal from '@/components/Share/CreateSharePersonModal'
import userPermission from '@/mixins/userPermission'
import { getVictimStatusFromVictimInfo } from '@/helpers/victiminfo'

export default {
  name: 'addperson',
  mixins: [userPermission],
  components: {
    PersonForm,
    CreateSharePersonModal
  },
  computed: {
    ...mapGetters({
      person: 'getCreatePerson',
      createdPerson: 'getRecentlyCreatedPerson',
      orientation_options: 'getOrientationOptions',
      race_options: 'getRaceOptions',
      services_provided: 'getServicesProvided',
      discharge_options: 'getDischargeOptions',
      victim_status_options: 'getVictimStatusOptions',
      immigration_options: 'getImmigrationOptions',
      ethnicity_options: 'getEthnicityOptions',
      gender_identity: 'getGenderIdentityOptions',
      gender_options: 'getGenderOptions',
      months: 'getMonths',
      showCreatedModal: 'showCreatedModal',
      sharePersonRecords: 'sharePersonRecords',
      // userShareAllowedGroups: 'userShareAllowedGroups',
      getGroupsByOrg: 'getGroupsByOrg',
      userTransferAllowed: 'userTransferAllowed',
      userCurrentContext: 'userCurrentContext',
      sexTraffickingMeans: 'getSexTraffickingMeans',
      laborTraffickingMeans: 'getLaborTraffickingMeans',
      victimInfoCreateError: 'getVictimInfoCreateError'
    }),
    hasGroups: function () {
      let groups = this.getGroupsByOrg
      return groups.length > 0
    }
  },
  methods: {
    handleOk (evt) {
      if (this.createdPerson.id) {
        this.$router.push({ path: `/person/${this.createdPerson.id}` })
      } else {
        this.$router.push({ path: `/dashboard` })
      }
      // Reset modal
      this.$store.commit('setShowCreatedModal', false)
    },
    handleShare (evt) {
      this.$store.commit('setShowCreatedModal', false)
      this.personId = this.createdPerson._id
      this.personFid = this.createdPerson.id
      if (!this.$store.getters.userCurrentContext.group.isOwningGroup && this.$store.getters.userCurrentContext.group.id) {
        this.processShareRecord()
      } else {
        this.$bvModal.show('create-share-person')
      }
    },
    processShareRecord: function () {
      const personId = this.personId
      const personFid = this.personFid
      const groupId = this.$store.getters.userCurrentContext.group.id

      if (!personId || !groupId) {
        this.$store.commit('SET_SHARE_PERSON_RESPONSE', { success: false, error: { code: 'INVALID_API_CALL', message: 'Incorrect parameters' } })
      }

      if (personId && groupId) {
        this.$store.dispatch('sharePerson', {
          personId,
          personFid,
          groupId,
          fullTransfer: false,
          fullShare: false
        })
      }
    },
    processPersonRecord () {
      this.$validator.validate().then(async (result, error) => {
        if (result) {
          let person = this.person

          // https://github.com/sagalbot/vue-select/issues/239#issuecomment-333623907
          _.each(['p_le_agency', 'p_cac_agency'], function (field) {
            if (_.isObject(person[field]) && person[field].value) {
              person[field] = person[field].value
            }
          }, this)

          if (this.person.selectedServices) {
            this.person.s_selected_services = this.person.selectedServices.join(',')
          }

          await this.$store.dispatch('createPerson', this.person)
          await this.updatePersonVictimInfo()
         } else {
          alert('Please review form and submit all required answers.')
        }
      }
      )
    },
    addOrUpdatePersonRecord () {
      this.shareAddon = false
      this.processPersonRecord()
    },
    addOrUpdatePersonRecordAndShare () {
      this.shareAddon = true
      this.processPersonRecord()
    },
    reroutePerson (event) {
      this.$router.push({ path: `/person/` + event })
    },
    updateVictimInfo (newValue) {
      this.victimInfo = newValue
    },
    async updatePersonVictimInfo () {
        await this.$store.dispatch('bulkUpdatePersonVictimInfo', {
          person: this.createdPerson._id,
          victimInfo: this.victimInfo
        })

        if (this.victimInfoCreateError) {
          this.$store.commit('SET_VICTIM_INFO_CREATE_ERROR', false)
          return
        }

        const orgId = _.get(this.userCurrentContext, 'organization.id', false)
        const groupId = _.get(this.userCurrentContext, 'group.id', false)

        return this.$store.dispatch('updatePerson', {
          _id: this.createdPerson._id,
          b_confirmed: getVictimStatusFromVictimInfo(this.victimInfo),
          orgId,
          groupId
        })
    }
  },
  watch: {
    userCurrentContext: {
      async handler (newValue) {
        if (newValue) {
          this.personOrganizationOwner = _.get(this.userCurrentContext, 'organization.id')
          await this.$store.dispatch('getGroupsByOrg', { id: this.personOrganizationOwner })
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.selectedGroup = this.$store.getters.userCurrentContext.group
  },
  data: function () {
    return {
      t1plus: '',
      errors: [],
      month: '',
      day: '',
      year: '',
      personId: 0,
      personFid: '',
      personOrganizationOwner: 0,
      shareAddon: false,
      shareRecordId: 0,
      selectedGroup: {},
      victimInfo: []
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/views/t1/Admin/AddPerson.vue